export const GET_PACKAGE_LOADING = "loading";
export const GET_PACKAGE_SUCCESS = "success";
export const GET_PACKAGE_ERROR = "error";
